module.exports = __webpack_public_path__ + "static/media/location.aad0b3cd.svg";